export const consentFilterOptions = [
	'Active Consents',
	'Pending Consent Requests',
	'Rejected Consents',
	'Revoked Consents',
];

export const customerFilterOptions = [
	'Customers Onboarded',
	'Successful Data Requests',
	'Failed Data Requests',
];

export const pfmCustomerFilterOptions = [
	'Active Subscriptions',
	'Currently Linked Accounts',
	'Inactive Subscriptions',
	'Total Accounts',
	'Customers Onboarded',
];
